import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController } from 'ionic-angular';
import { DepartamentosEditarPage } from '../../pages/departamentos-editar/departamentos-editar'
import { Departamentos } from '../../models/Departamentos';
import { DepartamentosProvider } from '../../providers/departamentos/departamentos'
import { PaisesProvider } from '../../providers/paises/paises'
import { CompaniasProvider } from '../../providers/companias/companias'
import { AuthService } from '../../providers/auth-service'

@IonicPage()
@Component({
  selector: 'page-departamentos',
  templateUrl: 'departamentos.html',
  providers: [ AuthService ]
})
export class DepartamentosPage {
  Departamentos:any[]=[]
  DepartamentosData:any[]=[]
  paises:any[]=[]
  codigoDepartamento:string =""
  nombreDepartamento:string =""
  departamentosId:string =""
  paisesId:string = ""
  id:string =""
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  constructor(public navCtrl: NavController, public navParams: NavParams,
              public servicioDepartamento:DepartamentosProvider,
              public modalControllers:ModalController,
              public servicioPaises:PaisesProvider ,
              public servicioCompania:CompaniasProvider,
              public auth: AuthService
            ) {
                this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo'])
                .then((val)=>{
                  if(val){
                    this.nombreCompaniaHeader = val['nombreCompania']
                    this.nombreCargoHeader = val['nombreCargo']
                  }
                })
                this.cargarServicioDepartamento()
  }


  ionViewDidLoad() {
    this.cargarServicioDepartamento()
   
  }

  guardarDepartamento(){
    
        for(var i = 0; i < this.Departamentos.length; i++) {
            if (this.Departamentos[i].paisesId ==  this.Departamentos['paisesId']) {
              let valor:Departamentos = {
                codigoDepartamento: this.codigoDepartamento,
                nombreDepartamento: this.nombreDepartamento,
                paisesId: this.Departamentos['paisesId'],
                queHago: "I",
                nombreTabla: "departamentos",
                name: "dataDynamicCrud"
                }
           
                this.servicioDepartamento.guardar(valor)
                .subscribe(
                  res => {
                    this.actualizarValores()
                  }, 
                  err => console.log(err)
                  )
                break;
            }
      }    
    }
    
    
      editarDepartamentos(DepartamentosData:any){
        let modal = this.modalControllers.create(DepartamentosEditarPage, {DepartamentosData:DepartamentosData})
        modal.present();
    
        modal.onDidDismiss( data => {
          if(data){
            this.editarRegistrosDepartamento(DepartamentosData, data);
          }
    
        })
    
      }
    
    editarRegistrosDepartamento(originalTodo: any, modificadoTodo: any){
        const index = this.DepartamentosData.indexOf(originalTodo);
        
            this.DepartamentosData = [
              ...this.DepartamentosData.slice(0,index),
              modificadoTodo,
              ...this.DepartamentosData.slice(index + 1)
            ]
            modificadoTodo.queHago = "A"
            modificadoTodo.nombreTabla = "departamentos"
            modificadoTodo.name = "dataDynamicCrud"
           this.servicioDepartamento.actualizar(modificadoTodo)
           .subscribe(
            res => {
              this.actualizarValores()
              this.cargarServicioDepartamento()
            },
            err => {
              console.log(err)}
          )
    }
    
    
      eliminarDepartamentos(todo:any){
    
        //this.DepartamentosData.splice(todo,1);
        //this.servicioDepartamento.eliminar(this.DepartamentosData)
        let data = todo
        let Departamentos:Departamentos = 
         {
          departamentosId :data.departamentosId,
          codigoDepartamento:"",
          nombreDepartamento:"",
          paisesId:data.paisesId,
          queHago:"E",
          nombreTabla:"departamentos",
          name:"dataDynamicCrud"
        }
        
        // Departamentos['queHago'] = "E"
        // Departamentos['name'] = "dataDynamicCrud"
        // Departamentos['nombreTabla'] = "departamentos"
        // Departamentos['DepartamentosId'] = data.DepartamentosId
        this.servicioDepartamento.eliminar(Departamentos)
        .subscribe(
          res => {
          
            this.actualizarValores()
          
            this.cargarServicioDepartamento()
          },
          err => console.log(err)
        ) 

      }
    
      
              cargarServicioDepartamento(){
                this.servicioPaises.buscar()
                .subscribe((data) => {
                  this.Departamentos = []
                  this.Departamentos = data
                  
                  this.servicioDepartamento.buscar()
                    .subscribe((datos)=>{
                      this.DepartamentosData = datos
           
                      // for(var i = 0; i < data.length; i++){
                      //   var k = 0
                      //   if(datos.length>0){
                      //     for(k < datos.length && datos.length > 0;;){
                            
                      //       if(datos[k]['paisesId'] === data[i]['paisesId']){
                           
                      //         this.DepartamentosData[k]['paisesId'] =  data[i]['paisesId']
                      //       }
                      //       if(k + 1< datos.length){
                      //         k = k + 1
                      //       }else{
                      //         break;
                      //       }
                            
                      //     }
                      // }
                      // }

                    }, error => {
                      console.log(error)
                    })
                }, error => {
                  console.log(error)
                })       
              }          
                  valorBuscado(dato) {
                    
                    if(dato.paisesId ===this.Departamentos['paisesId']){
                      return dato.paisesId
                    }
                }  
                
      actualizarValores() {
        this.DepartamentosData = []
        this.codigoDepartamento = ""
        this.nombreDepartamento = ""
        this.paisesId = ""
        this.Departamentos = []
        this.Departamentos['paisesId'] = 0
        this.cargarServicioDepartamento()
      }     
  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }  
}





// WEBPACK FOOTER //
// ./src/pages/departamentos/departamentos.ts